export default __webpack_public_path__ + "static/media/music.9a93a223.svg";